// Card #2164 design (recorded on the card): HYBRID. The parser passes any
// well-formed cause token through (lowercase snake_case, <= 64 chars), so a
// future foxbox cause is never flattened to null here. The display layer
// (FvdPushFailureCauseChip.CAUSE_DISPLAY, and CAUSE_REASON_LABEL_KEY below,
// shared with FvdPushStatusIcon) keeps an explicit translated label per
// KNOWN cause; a well-formed cause the FE has never heard of renders as
// "Other (<cause>)" (reviewQueue.fvdFailures.cause.other), so the operator
// still sees foxbox's own token instead of "Unclassified", and no FE release
// is needed for it to display at all. `null` still means "no classification
// available" (non-JSON row, missing/malformed cause) and stays Unclassified.
//
// Card #1608 — foxbox (#884's PushStatusReport.cs) encodes a ride's push
// failure as a JSON string: {cause: "locked" | "unknown", attempts: N,
// rawError: "..."}, self-truncated to stay under score-api's exact 2000-char
// `error` cap (a hard 400 on overage, never a server-side truncation, so
// foxbox truncates before sending). Older rows, or any other writer, may
// instead carry a plain non-JSON string. Parse the JSON shape; degrade
// gracefully to { cause: null, attempts: null, rawError: <original string> }
// on anything that isn't exactly that shape, rather than throwing or
// rendering "[object Object]"/blank.
// Static i18n key per known cause (this repo requires static key literals,
// never `cause.${cause}`). Mirrors foxbox's PushStatusReport.Map causes.
export const CAUSE_REASON_LABEL_KEY = {
  locked: "reviewQueue.fvdFailures.cause.locked",
  unknown: "reviewQueue.fvdFailures.cause.unknown",
  no_points_basis: "reviewQueue.fvdFailures.cause.noPointsBasis",
  no_fvd_match: "reviewQueue.fvdFailures.cause.noFvdMatch",
  write_not_verified: "reviewQueue.fvdFailures.cause.writeNotVerified",
  fvd_unavailable: "reviewQueue.fvdFailures.cause.fvdUnavailable",
};
export const OTHER_CAUSE_LABEL_KEY = "reviewQueue.fvdFailures.cause.other";

// Own-property check: a cause token of "constructor"/"toString" must not
// resolve to an Object.prototype member.
export function isKnownFvdPushCause(cause) {
  return typeof cause === "string" && Object.prototype.hasOwnProperty.call(CAUSE_REASON_LABEL_KEY, cause);
}

const CAUSE_TOKEN = /^[a-z0-9_]{1,64}$/;

export function parseFvdPushError(raw) {
  if (raw == null) return { cause: null, attempts: null, rawError: null };
  if (typeof raw !== "string") return { cause: null, attempts: null, rawError: String(raw) };

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { cause: null, attempts: null, rawError: raw };
  }

  if (!parsed || typeof parsed !== "object" || typeof parsed.rawError !== "string") {
    return { cause: null, attempts: null, rawError: raw };
  }

  const cause = typeof parsed.cause === "string" && CAUSE_TOKEN.test(parsed.cause) ? parsed.cause : null;
  const attempts = Number.isFinite(parsed.attempts) ? parsed.attempts : null;
  return { cause, attempts, rawError: parsed.rawError };
}

export default parseFvdPushError;
